// getNodeViewNodes.js

// Hooks
import { getDisplayType } from 'node/groups/groupChildNodesByType';

// Utilities
import { isCatchAllView } from 'utilities/ViewRows';

export default function getNodeViewNodes({
  activeTypeKey,
  applyFilters,
  applySorts,
  childNodes,
  descendantNodes,
  view,
}) {
  const includeDescendants = Boolean(view?.includeDescendants);
  const sourceNodes = includeDescendants
    ? (Array.isArray(descendantNodes) ? descendantNodes : [])
    : (Array.isArray(childNodes) ? childNodes : []);

  let items = sourceNodes;

  if (activeTypeKey && activeTypeKey !== '__HIGHLIGHT__') {
    items = items.filter((item) => getDisplayType(item) === activeTypeKey);
  }

  const viewFilters = Array.isArray(view?.filters) ? view.filters : [];
  const viewSorts = Array.isArray(view?.sorts) ? view.sorts : [];
  const catchAllView = isCatchAllView(view);
  const isTableView = String(view?.type || '').trim().toUpperCase() === 'TABLE';
  const effectiveSorts = (isTableView && catchAllView)
    ? [{ field: 'autonumber', direction: 'asc' }]
    : viewSorts;

  const filteredItems = viewFilters.length
    ? items.filter((item) => applyFilters(item, viewFilters))
    : items;

  return effectiveSorts.length ? applySorts(filteredItems, effectiveSorts) : filteredItems;
}
